export default "__VITE_PUBLIC_ASSET__41f7eed2__"